import { ValueCalculator } from "./value-calculator";

export class PidController extends ValueCalculator {
  constructor(Kp) {
    super(0);
    this.Kp = Kp;
  }

  calculate(setpoint) {
    this.measuredValue += this.Kp * (setpoint - this.measuredValue);
    return this.measuredValue;
  }
  /*
  constructor(dt, Kp, Ki, Kd) {
    this.dt = dt; // loop interval time
    this.Kp = Kp; // proportional gain
    this.Ki = Ki; // integral gain
    this.Kd = Kd; // derivative gain
    this.preError = 0;
    this.integral = 0;

    this.A0 = this.Kp + this.Ki * this.dt;
    this.A1 = -this.Kp;
    this.error = [0,0,0]; // e(t), e(t-1), e(t-2)
    this.output = 0;  // Usually the current value of the actuator
    this.A0d = this.Kd / this.dt;
    this.A1d = -2.0 * this.Kd / this.dt;
    this.A2d = this.Kd / this.dt;
    let N = 5;
    let tau = this.Kd / (this.Kp * N) // IIR filter time constant
    this.alpha = this.dt / (2 * tau);
    this.d0 = 0;
    this.d1 = 0;
    this.fd0 = 0;
    this.fd1 = 0;
  }
  */

  /*
  calculate(setpoint, measuredValue) {
    // Calculate error
    let error = setpoint - measuredValue;
    // Proportional term
    let Pout = this.Kp * error;
    // Integral term
    this.integral += error * this.dt;
    let Iout = this.Ki * this.integral;
    // Derivative term
    let derivative = (error - this.preError) / this.dt;
    let Dout = this.Kd * derivative;

    // Calculate total output
    let output = Pout + Iout + Dout;

    // Save error to previous error
    this.preError = error;

    return output;
  }
  */

  /*
  calculate(setpoint, measuredValue) {
    this.error[2] = this.error[1];
    this.error[1] = this.error[0];
    this.error[0] = setpoint - measuredValue;
    // PI
    this.output += this.A0 * this.error[0] + this.A1 * this.error[1];
    // Filtered D
    this.d1 = this.d0;
    this.d0 = this.A0d * this.error[0] + this.A1d * this.error[1] + this.A2d * this.error[2];
    this.fd1 = this.fd0;
    this.fd0 = ((this.alpha) / (this.alpha + 1)) * (this.d0 + this.d1) - ((this.alpha - 1) / (this.alpha + 1)) * this.fd1;
    this.output += this.fd0; 
    return this.output;
  }
  */
}
